﻿/// <reference path="../lib/jquery.d.ts" />
/// <reference path="../lib/googleMaps.d.ts" />
import {Controller} from "./helpers/controller";
import {shim} from "./helpers/shim";
import InfoWindow = google.maps.InfoWindow;

export interface Marker {
    content?: Element,
    name: string,
    lat: number,
    lng: number,
}

export class GoogleMapControl extends Controller {
    
    private timer: number | undefined;
    private map?: google.maps.Map;

    private hasMapsAttribute:boolean = $(this._element).data('googlemap') != undefined;

    private startlat:number = $(this._element).data('googlemap-startlat');
    private startlng:number = $(this._element).data('googlemap-startlng');
    private marker:Marker = $(this._element).data('googlemap-marker');
    
    private currentInfoWindow?:InfoWindow;

    private gMarkersTracker: google.maps.Marker[] = [];

    constructor(element: HTMLElement) {
        super(element);
        
        this.loadGoogleMaps();
    }


    public loadGoogleMaps = () => {

        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
            if (typeof (shim('google')) === 'undefined' || typeof (shim('google').maps) === 'undefined') {
                if (document.querySelectorAll('#google-maps-api').length <= 0) {
                    let tag = document.createElement('script');
                    tag.src = '//maps.googleapis.com/maps/api/js?key=AIzaSyAz54REQBZR3ziqLFLa92AC5L9Zr4Be4oU&libraries=places&callback=Function.prototype';
                    tag.id = 'google-maps-api';
                    let firstScriptTag = document.getElementsByTagName('script')[0];
                    firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);
                }

                this.loadGoogleMaps();
            } else {

                this.map = new google.maps.Map($(this._element).get()[0] as HTMLElement, {
                    zoom: 12,
                    streetViewControl:false,
                    fullscreenControl:false,
                    mapTypeControl: false
                });
                
                if (this.hasMapsAttribute){
                    this.renderMap([this.marker],this.startlat,this.startlng);
                }
            }
        }, 50);
    }

    public renderMap = (markers: Array<Marker>, lat:number, lng:number) => {
        if (this.map == undefined) {
            
        } else {
            this.map.setCenter({ lat, lng });
            this.removeAllMarkers();
        }

        let gMarkers: Array<google.maps.Marker> = []
        markers.forEach((marker) => {
            this.addMarker(marker);
        })
    }
    
    addMarker = (marker: Marker) => {
        let gMarker = new google.maps.Marker(
            {
                map: this.map,
                position: new google.maps.LatLng({lat: marker.lat, lng: marker.lng}),
                icon: '/resources/images/mapPin.svg'
            });

        if (marker.content != null){
            const infowindow = new google.maps.InfoWindow({
                content: marker.content,
                ariaLabel: marker.name,
            });
            gMarker.addListener("click", () => {
                this.currentInfoWindow?.close();
                infowindow.open({
                    anchor: gMarker,
                    map: this.map,
                });
                this.currentInfoWindow = infowindow;
            });
        };

        this.gMarkersTracker.push(gMarker);
    }

    removeAllMarkers = () => {
        for (let i = 0; i < this.gMarkersTracker.length; i++) {
            this.gMarkersTracker[i].setMap(null);
        }
        this.gMarkersTracker = [];
    };
}

